import { getCookie, setCookie } from '../../utils/cookie';

document.addEventListener('alpine:init', () => {
  Alpine.data('password', () => ({
    visible: false,
    postId: null,
    password: '',
    submitting: false,
    error: null,
    $root: null,

    init() {
      this.$root = this.$el;
      this.postId = this.$el.dataset.postId;
      this.$nextTick(() => this.ready());
    },

    ready() {
      const cookie = getCookie(`wp-vb-password-${this.postId}`);

      if (cookie) {
        this.password = cookie;
        this.getContent();
      } else {
        this.visible = true;
      }
    },

    getContent() {
      this.submitting = true;
      this.error = null;

      const query = new URLSearchParams({
        action: 'content',
        post_id: this.postId,
        password: this.password,
      });

      fetch(`${window.ajaxurl}?${query}`)
        .then((response) => response.json())
        .then((response) => {
          if (response.success) {
            setCookie(`wp-vb-password-${this.postId}`, this.password, 365);
            const content = document.createElement('div');
            this.$root.after(content);
            content.outerHTML = response.data;
            setTimeout(() => window.dispatchEvent(new CustomEvent('init')));
            this.visible = false;
          } else {
            this.error = response.data;
            this.visible = true;
          }
        })
        .finally(() => (this.submitting = false));
    },

    onSubmit() {
      if (!this.submitting) {
        this.password = document.getElementById('password').value;
        this.getContent();
      }
    },
  }));
});